// extracted by mini-css-extract-plugin
export default {"team":"agd2T","team__listWrapper":"woS_A","team__headline":"hV1h7","team__list":"pIGVS","team__item":"RWacI","team__image":"JpeHo","team__name":"sVQRB","team__position":"BoNJD"};